<li ngbDropdown class="nav-item dropdown-notification mr-25">
  <a class="nav-link" ngbDropdownToggle id="navbarNotificationDropdown"><i class="ficon" data-feather="bell"></i><span
      class="badge badge-pill badge-up" [ngClass]="allRead() ? 'badge-success' : 'badge-danger'"
      *ngIf="notificationsData?.length > 0">{{ getUnreadCount() }}</span></a>
  <ul ngbDropdownMenu aria-labelledby="navbarNotificationDropdown"
    class="dropdown-menu dropdown-menu-media dropdown-menu-right">
    <!-- Notifications header -->
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <h6 class="notification-title mb-0 mr-auto align-self-center">Bildirimleri</h6>

        <button class="btn btn-sm btn-icon btn-flat-warning mr-1" style="height:auto; align-self:center;"
          (click)="getNotExpiryNotifications()" [disabled]="isRefreshing">
          <i data-feather="refresh-cw"></i>
        </button>

        <button class="btn btn-sm btn-flat-info" style="height:auto; align-self:center;" (click)="markAllAsRead()"
          [disabled]="isRefreshing">
          Tümü
        </button>

        <div class="badge badge-pill badge-light-primary align-self-center" *ngIf="notificationsData?.length > 0">
          {{notificationsData?.length}}
        </div>
      </div>
    </li>
    <!--/ Notifications header -->

    <!-- Notifications content -->
    <li class="scrollable-container media-list" [perfectScrollbar]>
      <a class="d-flex" href="javascript:void(0)" (click)="createUserNotification(item.id,true)"
        *ngFor="let item of notificationsData">
        <!--(click)="showActionDetail(item.id)"-->
        <div class="media d-flex align-items-start">
          <div class="media-left">
            <div class="avatar" [ngClass]="{
              'bg-light-info': item.type === 1 && !item.isRead,
              'bg-light-success': item.type === 2 && !item.isRead,
              'bg-light-warning': item.type === 3 && !item.isRead,
              'bg-light-danger': item.type === 4 && !item.isRead,
              'bg-light-secondary': item.isRead
            }">
              <span class="avatar-content">
                <i [data-feather]="item.isRead ? 'eye-off' : 'eye'"></i>
              </span>
            </div>

          </div>
          <div class="media-body">
            <p class="media-heading" [innerHTML]="item.title"></p>
            <!-- <small class="notification-text">{{item.description}}</small>-->
          </div> 
            <small class="notification-text"> {{ item.expireAt ? (item.expireAt | date:'dd.MM.yyyy') : 'Süresiz'
              }}</small>
          </div>
      </a>
    </li>
  </ul>
</li>